import {ThreatMatchQueryParams} from "@app2/fraud/type-defs";

export const initialThreatMatchParams: ThreatMatchQueryParams = {
    sortField: "subscribed",
    orderDesc: "true",
    stateFilter: "enabled",
};

export const fileHashRegex = /\b([0-9a-f]{2}){16,32}\b/i;